import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  height: 100dvh;
  padding: 0 25px;
  background-color: #fafafa;
  font-family: 'SUIT', sans-serif;

  .margin35 {
    height: 35px;
  }
  .margin40 {
    height: 40px;
  }
  .margin50 {
    height: 50px;
  }
  .margin60 {
    height: 60px;
  }
  .margin250 {
    height: 250px;
  }
`;
